export default __webpack_public_path__ + "static/media/popup-card-small.f6013500.png";